import { createUseStyles } from 'react-jss'

export default createUseStyles({
  column: {
    textAlign: 'center'
  },
  container: {
    '@media (max-width: 1152px)': {
      width: '100%'
    }
  },
  paragraph: {
    marginBottom: '1rem !important'
  },
  section: {
    padding: '9rem 1.5rem'
  },
  title: {
    marginBottom: '.25rem !important'
  },
  logo: {
    objectFit: 'contain'
  }
})
